var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui_explain_container"},[_c('div',{staticClass:"img_box"},[_c('img',{attrs:{"src":require("../../assets/images/kaifazhong.png"),"alt":""}})]),_c('p',{staticClass:"desc"},[_vm._v("正在开发中...")])])
}]

export { render, staticRenderFns }